import { styled, Theme } from '@material-ui/core';
import { TrajectorySectionCode } from 'src/config/api/models/Trajectory';
import { IconButton } from 'src/modules/shared/components';

export const Wrapper = styled('div')<
  Theme,
  { page?: TrajectorySectionCode; expanded: string | boolean }
>(({ theme, page, expanded }) => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  justifyContent: 'space-between',
  alignItems: page === '0' || page === '1' || expanded ? 'baseline' : 'center',
  gap: '16px',
}));

export const InfoWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontFamily: theme.config.primaryFontFamily,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: 400,
}));

export const TitleDescriptionWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  fontFamily: theme.config.primaryFontFamily,
  fontSize: theme.typography.body1.fontSize,
  gap: '4px',
}));

export const StyledTitle = styled('div')<Theme>(({ theme }) => ({
  fontFamily: theme.config.primaryFontFamily,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: 700,
  flex: 1,
  marginRight: theme.spacing(2),
  color: theme.palette.primary.dark,
}));

export const StyledDescription = styled('div')<Theme>(({ theme }) => ({
  margin: 0,
  overflowWrap: 'anywhere',
  '& > *': {
    margin: 0,
  },
}));

export const StyledHeader = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  [theme.breakpoints.down('xs')]: {
    display: 'block',
  },
}));

export const StyledIconButton = styled(IconButton)({
  width: '3rem',
  height: '3rem',
  marginRight: '1rem',
});

export const ScoreInfo = styled('span')<Theme>(({ theme }) => ({
  fontSize: '1.4rem',
  marginRight: '1.5rem',
  color: theme.palette.grey['700'],
}));

export const IconWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  gap: '3rem',
  alignItems: 'baseline',
}));
